    import codiggerFont from 'assets/style/common/font/JetBrainsMono-Regular.ttf?url';
function CreateUuid(len = 8,radix = 10)
{
        let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
        let uuid = [],i
        let rdx = radix || chars.length
        if (len)
        {
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * rdx]
        }
        else
        {
            let r
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
            uuid[14] = '4'
            for (i = 0; i < 36; i++)
            {
                if (!uuid[i])
                {
                    r = 0 | Math.random() * 16
                    uuid[i] = chars[i === 19 ? r & 0x3 | 0x8 : r]
                }
            }
        }
        return Number(uuid.join(''))
}
	export const chain = [];
	export const chainPush = (task) => {
	    if (Array.isArray(task))
	    {
	        for (let i = 0; i < task.length; i++)
	        {
	            chainPush(task[i]);
	        }
	        return;
	    }
	    chain.push(task);
	};
	export const chainExecute = () => {
	    return new Promise((resolve, reject) =>
	    {
	        const execute = (result) =>
	        {
	            const task = chain.shift();
	            if (!task)
	            {
	                resolve();
	                return;
	            }
	            task.apply(this, result)
	                .then((...rest) =>
	                {
	                    execute(rest);
	                })
	                .catch((e) =>
	                {
	                    console.log('rest error', e);
	                    reject();
	                })
	        }
	        execute();
	    })
	}
	export const isSafari = () =>
	{
	    const userAgent = navigator.userAgent.toLocaleLowerCase();
	    return userAgent.includes('safari') && !userAgent.includes('chrome');
	}
	export const injectFont = (iframe) => {
	    const myFont = new FontFace('CodiggerFont', `url(${codiggerFont})`, { display: 'swap' });
	    document.fonts.add(myFont);
	    iframe?.contentDocument?.fonts?.add(myFont);
	    myFont.load().then(() =>
	    {
	        if (iframe.contentDocument)
	        {
	            injectFontStyleInfoIframe(iframe.contentDocument)
	        }
	        else
	        {
	            iframe.addEventListener('load', function ()
	            {
	                try
	                {
	                    injectFontStyleInfoIframe(iframe.contentDocument)
	                }
	                catch (err)
	                {
	                    console.error(err)
	                }
	            })
	        }
	    })
	}
	const injectFontStyleInfoIframe = (targetWindow) =>
	{
	    const code = `
	        @font-face {
	            font-family: "CodiggerFont";
	            src: url('${codiggerFont}');
	            font-display: swap;
	        }
	        html, body {
	            font-family: "CodiggerFont", PingFangSC-Regular, Micrsoft YaHei, WenQuanYi Micro Hei, Source Han Sans !important;
	        }
	    `;
	    try
	    {
	        const style = targetWindow.createElement('style');
	        style.type = 'text/css';
	        style.rel = 'stylesheet';
	        try {
	            style.appendChild(document.createTextNode(code));
	        }
	        catch (error) {
	            console.log(error)
	            style.styleSheet.cssText = code;
	        }
	        targetWindow.head?.appendChild(style);
	    }
	    catch (error) {
	        console.error('injectFont', error);
	    }
	}
	/**
	* 将对象属性名从下划线命名（如parent_env）转为小驼峰命名（如parentEnv）
	* @param {Object|Array} data - 要处理的对象或数组
	* @returns {Object|Array} 处理后的对象或数组
	*/
	export const underscoreToCamelCase = (data) =>
	{
	    if (typeof data !== 'object' || data === null) return data;
	    if (Array.isArray(data)) {
	        return data.map(item => underscoreToCamelCase(item));
	    }
	    const result = {};
	    Object.entries(data).forEach(([key, value]) => {
	        const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
	        result[camelKey] = underscoreToCamelCase(value);
	    });
	    return result;
	}
	/**
	* 版本号大小比较
	* @param {string} v1 版本号1
	* @param {string} v2 版本号2
	* @returns
	* 0:v1=v2
	* 1:v1>v2
	*  -1:v1<v2
	*/
	export const compareVersions = (v1, v2) =>
	{
	    const parts1 = v1.split('.').map(Number);
	    const parts2 = v2.split('.').map(Number);
	    for(let i = 0;i < Math.max(parts1.length, parts2.length);i++)
	    {
	        const num1 = parts1[i] || 0;
	        const num2 = parts2[i] || 0;
	        if(num1 > num2) return 1;
	        if(num1 < num2) return -1;
	    }
	    return 0;
	}
	export function promiseWithTimeout(promise, timeoutMs = 5000, timeoutMsg = 'Operation timed out')
	{
	    const timeoutPromise = new Promise((_, reject) =>
	    {
	        setTimeout(() =>
	        {
	            reject(new Error(timeoutMsg))
	        }, timeoutMs)
	    })
	    return Promise.race([promise, timeoutPromise]);
	}
	/**
	* 时间戳转日期格式
	* @param time
	* @param format
	* @returns {*}
	*/
	export function formatDateTime (time, format)
	{
	    let t = new Date(time);
	    let tf = function (i)
	    {
	        return (i < 10 ? '0' : '') + i;
	    };
	    return format.replace(/yyyy|MM|dd|HH|mm|ss|g|q/g, function (a)
	    {
	        switch (a)
	        {
	            case 'yyyy':
	                return tf(t.getFullYear());
	            case 'MM':
	                return tf(t.getMonth() + 1);
	            case 'mm':
	                return tf(t.getMinutes());
	            case 'dd':
	                return tf(t.getDate());
	            case 'HH':
	                return tf(t.getHours());
	            case 'ss':
	                return tf(t.getSeconds());
	            case 'g':
	                return tf(t.getMilliseconds());
	            default:
	                return '';
	        }
	    });
	}
	export function findAllElements(doc = window.document, className = 'empower-title', windowId)
    {
	    const result = [];
	    try {
	        const currentDocElements = doc.querySelectorAll(`.${className}`);
	        result.push(...Array.from(currentDocElements));
            const iframeId = !windowId ? '' : `#iframe-${windowId}`;
	        const iframes = doc.querySelectorAll(`iframe${iframeId}`);
	        iframes.forEach(iframe =>
            {
	            try {
	                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
	                result.push(...findAllElements(iframeDoc));
	            }
	            catch (iframeErr)
	            {
	                console.error(`跳过跨域iframe（src: ${iframe.src}），无法查询内部元素`, iframeErr);
	            }
	        });
	    }
        catch (err)
        {
	        console.error(`查询${className}元素时发生错误`, err);
	    }
	    return result;
	}
    export async function timeoutCallback(eventHandler, timeout = 3000, onTimeout)
    {
        let timer;
        let isTimeout = false;
        const timeoutPromise = new Promise((resolve, reject) =>
        {
            try
            {
                timer = setTimeout(() =>
                {
                    if (typeof onTimeout === 'function')
                    {
                        const timeoutResult = onTimeout();
                        !timeoutResult ? reject() : resolve(timeoutResult);
                    }
                    else
                    {
                        reject();
                    }
                }, timeout);
            }
            catch (err)
            {
                reject(err);
            }
        });
        try
        {
            const eventPromise = eventHandler();
            const result = await Promise.race([eventPromise, timeoutPromise]);
            clearTimeout(timer);
            return result;
        }
        catch (error)
        {
            clearTimeout(timer);
            console.error(error);
        }
    }
    export async function cancelCallback(eventHandler, timeout = 3000, onTimeout)
    {
        const controller = new AbortController();
        const timer = setTimeout(() =>
        {
            controller.abort();
            if (typeof onTimeout === 'function')
            {
                onTimeout();
            }
        }, timeout);
        try
        {
            const result = await eventHandler(controller.signal, ...args);
            clearTimeout(timer);
            return result;
        }
        catch (error)
        {
            clearTimeout(timer);
            console.error(error);
        }
    }
    export function sendNoticeMsg(appData, msgData)
    {
        const noticePlayPinia = window.top?.$trufflePinia?.['play.jimmie.notice.vue']?.useNoticePlayPinia();
        const noticePinia = window.top?.$trufflePinia?.['app.honourbell.notice.vue']?.useNoticePinia();
        if (!noticePlayPinia || !noticePinia) return null;
        const msg = constructorNoticeMsg(appData, msgData);
        const isOpen = noticePlayPinia.getNoticeOpenStatus;
        if (!isOpen)
        {
            noticePlayPinia.setNoticeOpenStatus(true, 'Fancy1');
        }
        noticePinia.setInboxType('message');
        noticePinia.receiveSocketNotice(msg);
    }
    function constructorNoticeMsg(app, msg)
    {
        const username = JSON.parse(localStorage.getItem('userInfo'))?.username;
        const uuid = CreateUuid();
        const message = {
            status: 1,
            groupId: null,
            footerZh: null,
            username,
            workstationName: null,
            hotFixImage: null,
            messageId: app.moduleName + '-' + uuid,
            runtime: 2,
            moduleName: app.moduleName,
            type: 1,
            contentZh: '',
            contentEn: '',
            buttonParams: null,
            messageLevel: 1,
            titleEn: '',
            headerEn: null,
            createUser: username,
            createTime: formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            isRead: 1,
            moduleStatus: '3',
            hotFixStatus: null,
            icon: app.icon,
            buttonType: '1',
            time: formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            peerName: app.peerName[0],
            updateWorkstations: null,
            updateModuleId: null,
            code: null,
            titleZh: '',
            titleEn: '',
            headerZh: null,
            instanceId: app.appInstanceId,
            operateIn: 'User Space',
            buttonNameEn: null,
            hotFixErrorMessage: null,
            notificationType: 'App',
            hotFixMeetingCode: null,
            isUpdateSuccess: 0,
            footerEn: null,
            hotFixSessionId: null,
            level: 6,
            deviceId: null,
            buttonNameZh: null,
            externConfig: '{}',
            id: CreateUuid()
        };
        return { ...message, msg };
    }
	export default {
		chain,
		chainPush,
		chainExecute,
		isSafari,
		injectFont,
		injectFontStyleInfoIframe,
		underscoreToCamelCase,
		compareVersions,
		promiseWithTimeout,
		formatDateTime,
		findAllElements,
        timeoutCallback,
        cancelCallback,
        sendNoticeMsg
	}

